import { dateInputToUnixMillis } from '../../utils/dateTimeUtils';

export const ALL_TENANTS_FILTER = 'all';

export type LacDocumentsFilterState = {
  tenant: string;
  fromDay: string;
  toDay: string;
};

function parseDayParam(searchParams: URLSearchParams, key: string): string {
  const value = searchParams.get(key)?.trim() ?? '';
  return dateInputToUnixMillis(value) !== undefined ? value : '';
}

export function tenantOptionLabel(tenant: {
  name: string;
  displayName?: string | null;
}): string {
  return tenant.displayName?.trim() || tenant.name;
}

export function parseLacDocumentsFilterFromSearchParams(
  searchParams: URLSearchParams,
  { includeTenant }: { includeTenant: boolean },
): LacDocumentsFilterState {
  const tenantRaw = searchParams.get('tenant')?.trim() ?? '';
  const fromDay = parseDayParam(searchParams, 'from');
  const toDay = parseDayParam(searchParams, 'to');

  const tenant =
    includeTenant && tenantRaw !== '' && tenantRaw !== ALL_TENANTS_FILTER
      ? tenantRaw
      : ALL_TENANTS_FILTER;

  return {
    tenant,
    fromDay,
    toDay: fromDay !== '' && toDay !== '' && toDay >= fromDay ? toDay : '',
  };
}

export function buildLacDocumentsSearchParams({
  tenant,
  fromDay,
  toDay,
  includeTenant,
}: {
  tenant: string;
  fromDay: string;
  toDay: string;
  includeTenant: boolean;
}): URLSearchParams {
  const params = new URLSearchParams();

  if (includeTenant && tenant !== ALL_TENANTS_FILTER && tenant.trim() !== '') {
    params.set('tenant', tenant.trim());
  }

  if (fromDay !== '' && toDay !== '' && toDay >= fromDay) {
    params.set('from', fromDay);
    params.set('to', toDay);
  }

  return params;
}
